<template>
  <div id="about__pre-vestibular" class="pb-4 fade-in-up">
    <div id="header">
      <div class="img__header">
        <div class="bg__escuro"></div>
        <div class="bg__title">
          <b-container fluid="lg">
            <h2 class="text-title">Pré-Vestibular</h2>
          </b-container>
        </div>
      </div>
    </div>

    <BreadSistema class="bread__about" />

    <b-container fluid="lg" class="pt-4 pb-4">
      <div class="box-text">
        <div class="content-text">
          <h5 class="text-uppercase font-weight-bolder">Proposta Pedagógica</h5>
          <p class="lead font-weight-light">Nossas Coleções valorizam a liberdade de cada escola parceira para montar as
            opções de Cursos Preparatórios mais adequadas à sua realidade.</p>
          <p class="mt-3">A estrutura dos Módulos, por sua vez, permite que a equipe de professores trabalhe cada um dos
            temas de seu programa na velocidade apropriada.</p>
          <p>Os módulos são mensais, contendo todas as disciplinas. A teoria tem diversos níveis de desenvolvimento, e é
            acompanhada por baterias de exercícios de sala, de casa e complementares. Além da teoria
            da Redação, as propostas semanais ficam disponíveis no site do Sistema e são atualizadas constantemente.</p>

          <h5 class="font-weight-bolder mt-4">Extensivo</h5>
          <p class="font-weight-bolder">Planejado para atender a uma carga horária que varia de 36 a 46 horas/aula
            semanais.</p>
          <p>A teoria é bastante desenvolvida, com grande carga de exercícios. Perfeito para os alunos que estão
            concorrendo à vaga nos vestibulares mais exigentes.
          </p>
          <p>Adequado também para recuperar alunos que apresentam defasagem quanto aos conteúdos do Ensino Médio.</p>
          <h5 class="font-weight-bolder mt-4">Semi Extensivo</h5>
          <p class="font-weight-bolder">Planejado para atender a uma carga de 30 horas/aula semanais. A teoria é
            desenvolvida, com adequada carga de exercícios.
          </p>
          <p>É ideal para os alunos que vão prestar vestibular no meio do ano, ou deixaram para se preparar apenas no
            segundo semestre, ou ainda para aqueles que precisam de um reforço nos conteúdos do Ensino Médio e muito
            treino prático.
          </p>
          <hr>
          <div class="d-block mx-auto">
            <h5 class="text-center font-weight-bolder ">Para mais informações</h5>
            <p class="text text-center">
              Para mais informações sobre esse material, solicite hoje um consultor do Sistema de Ensino CPV.
            </p>
            <div class="d-flex justify-content-center">
              <b-button class="btn__consultor" :to="{ name: 'escolaParceira' }" variant="transparent">
                <i class="fa-regular fa-messages"></i>
                <span>Fale com um consultor</span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'ensino-infantil',
  components: { BreadSistema: () => import('../GlobalComponents/bread-sistema.vue') },
};
</script>

<style lang="scss" scoped>
#about__pre-vestibular {
  background-color: #ffffff;

  #header {
    .img__header {
      position: absolute;
      display: block;
      background-image: url('https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2019/10/11163513/pre-vestibular_comprimida.jpg');
      background-repeat: no-repeat;
      background-position: center center;
    }
  }

  h5 {
    color: #e98b24;
  }

  p {
    font-size: 16px;
    line-height: 22px;
  }

  .lead {
    font-size: 20px;
    line-height: 26px;
    padding: 0;
    margin: 0;
  }

  .btn__consultor {
    display: inline-flex;
    min-width: auto;
    min-height: auto;

    margin: 0px auto 0;
    padding: 8px 16px;

    gap: 6px;

    background-color: #e98b24;
    border: 1px solid #e98b24;
    border-radius: 5px;

    display: flex;
    align-items: center;

    font-size: 14px;
    line-height: 20px;

    color: #fdf3e9;

    .icon {
      width: 18px;
      height: 18px;

      display: flex;
      align-items: center;

      i {
        font-size: 14px;
        line-height: 20px;
      }
    }

    &:hover {
      background-color: #d27d20;
      transition: all 0.3s ease-in-out;
      border: 1px solid #d27d20;
    }
  }
}

@media screen and (min-width: 1200px) {
  .content-text {
    padding-left: 32px;
    padding-right: 32px;
  }
}

@media screen and (min-width: 320px) and (max-width: 1200px) {
  .content-text {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
